import { MobileMenuComponentType } from '@core/types';
import { useState } from 'react';

export const useMobileMenu = () => {
    const [chatActive, setChatActive] = useState<boolean>(false);
    const [slidesActive, setSlidesActive] = useState<boolean>(true);
    const [chapterActive, setChapterActive] = useState<boolean>(false);
    const [participantsActive, setParticipantsActive] = useState<boolean>(false);
    const [pollsActive, setPollsActive] = useState<boolean>(false);
    const [videoActive, setVideoActive] = useState<boolean>(false);

    const onMobileMenuItemClicked = (componentType: MobileMenuComponentType) => {
        setSlidesActive(componentType === MobileMenuComponentType.SLIDES);
        setChapterActive(componentType === MobileMenuComponentType.CHAPTER);
        setChatActive(componentType === MobileMenuComponentType.CHAT);
        setParticipantsActive(componentType === MobileMenuComponentType.PARTICIPANTS);
        setPollsActive(componentType === MobileMenuComponentType.POLLS);
        setVideoActive(componentType === MobileMenuComponentType.VIDEO);
    };

    return {
        onMobileMenuItemClicked,
        chatMobileMenuActive: chatActive,
        slidesMobileMenuActive: slidesActive,
        chapterMobileMenuActive: chapterActive,
        participantsMobileMenuActive: participantsActive,
        pollsMobileMenuActive: pollsActive,
        videoMobileMenuActive: videoActive
    };
};
